/*
 * BB-CUSTOM: Refresh the free-shipping bar inside the cart notification
 * after add-to-cart. Dawn only morphs product + button + cart icon.
 */
(function () {
  function patch() {
    var Ctor = customElements.get('cart-notification');
    if (!Ctor || Ctor.prototype.__bbFreeShippingPatched) return;
    var proto = Ctor.prototype;
    var original = proto.getSectionsToRender;
    proto.getSectionsToRender = function () {
      var sections = original.call(this);
      if (!sections.some(function (s) { return s.id === 'bb-free-shipping-bar'; })) {
        sections.push({ id: 'bb-free-shipping-bar' });
      }
      return sections;
    };
    proto.__bbFreeShippingPatched = true;
  }

  if (customElements.get('cart-notification')) {
    patch();
  } else {
    customElements.whenDefined('cart-notification').then(patch);
  }
})();
